// @ts-nocheck 2e2cc133
import * as selectors from './popupsSelectors';

export { selectors };
